import { Col, Label, ReactSelectBox } from "client/CommonComponents";
import { useMemo } from "react";

const TreeCare = (props?: any) => {
  const {
    managedEquipmentValues,
    equipmentTypeDropDownList,
    manufacturerDropDownList,
    horsePowerDropDownList,
    fuelTypeDropDownList,
    managedEquipRef,
    handleSelectionChange
  } = props;

  const manufacturerValue:any = useMemo(() => {
    return  manufacturerDropDownList?.find((i: any) => i?.key == managedEquipmentValues?.manufacturerId)
  }, [managedEquipmentValues?.manufacturerId, manufacturerDropDownList])

  const treeCareEquipmentTypeValue:any = useMemo(() => {
    return  equipmentTypeDropDownList?.find((i: any) => i?.key == managedEquipmentValues?.treeCareEquipmentTypeId)
  }, [managedEquipmentValues?.treeCareEquipmentTypeId, equipmentTypeDropDownList])

  const horsePowerValue:any = useMemo(() => {
    return  horsePowerDropDownList?.find((i: any) => i?.key == managedEquipmentValues?.horsePowerId)
  }, [managedEquipmentValues?.horsePowerId, horsePowerDropDownList])

  const fuelTypeValue:any = useMemo(() => {
    return  fuelTypeDropDownList?.find((i: any) => i?.key == managedEquipmentValues?.fuelTypeId)
  }, [managedEquipmentValues?.fuelTypeId, fuelTypeDropDownList])


  return (<>
     <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
        <Label data-attribute="TreeCare_Default_Label">Manufacturer</Label>
        <ReactSelectBox
          options={manufacturerDropDownList}
          onChange={(item: any, e: any) => handleSelectionChange(e, item,'manufacturerId',2)}
          value={manufacturerValue}
          selectRef={(element:any)=> managedEquipRef.current[1] = element}

         data-attribute="TreeCare_Default_SearchSelectBox" />
      </Col>
      <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
        <Label data-attribute="TreeCare_Default_Label_2">Equipment Type</Label>
        <ReactSelectBox
          options={equipmentTypeDropDownList}
          onChange={(item: any, e: any) => handleSelectionChange(e, item,'treeCareEquipmentTypeId',3)}
          value={treeCareEquipmentTypeValue}
          selectRef={(element:any)=> managedEquipRef.current[2] = element}

         data-attribute="TreeCare_Default_SearchSelectBox_2" />
      </Col>
      <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
          <Label data-attribute="TreeCare_Default_Label_3">Horse Power</Label>
          <ReactSelectBox
            options={horsePowerDropDownList}
            onChange={(item: any, e: any) => handleSelectionChange(e, item,'horsePowerId',4)}
            value={horsePowerValue}
            selectRef={(element:any)=> managedEquipRef.current[3] = element}
            isSearchable = {true}
           data-attribute="TreeCare_Default_SearchSelectBox_3" />
        </Col>
        <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
          <Label data-attribute="TreeCare_Default_Label_4">Fuel Type</Label>
          <ReactSelectBox
            options={fuelTypeDropDownList}
            onChange={(item: any, e: any) => handleSelectionChange(e, item,'fuelTypeId')}
            value={fuelTypeValue}
            selectRef={(element:any)=> managedEquipRef.current[4] = element}
           data-attribute="TreeCare_Default_SearchSelectBox_4" />
        </Col>
  </>)
}

export default TreeCare;
